function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { utils as utils_exports, AbstractAdapter, PSVError, SYSTEM, CONSTANTS as constants_exports } from '../core/index.module.js';
import { BoxGeometry, Mesh, Texture } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.CubemapAdapter 5.1.0
 * @copyright 2023 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var getConfig = utils_exports.getConfigParser({
  flipTopBottom: false,
  blur: false
});
var _CubemapAdapter = /*#__PURE__*/function (_AbstractAdapter) {
  _inherits(_CubemapAdapter, _AbstractAdapter);
  var _super = _createSuper(_CubemapAdapter);
  function _CubemapAdapter(viewer, config) {
    var _this;
    _classCallCheck(this, _CubemapAdapter);
    _this = _super.call(this, viewer);
    _this.config = getConfig(config);
    return _this;
  }
  _createClass(_CubemapAdapter, [{
    key: "supportsTransition",
    value: function supportsTransition() {
      return true;
    }
  }, {
    key: "supportsPreload",
    value: function supportsPreload() {
      return true;
    }
  }, {
    key: "loadTexture",
    value: function loadTexture(panorama) {
      var _this2 = this;
      var cleanPanorama = [];
      if (Array.isArray(panorama)) {
        if (panorama.length !== 6) {
          return Promise.reject(new PSVError("A cubemap array must contain exactly 6 images."));
        }
        for (var i = 0; i < 6; i++) {
          cleanPanorama[i] = panorama[_CubemapAdapter.CUBE_ARRAY[i]];
        }
      } else if (_typeof(panorama) === "object") {
        if (!_CubemapAdapter.CUBE_HASHMAP.every(function (side) {
          return !!panorama[side];
        })) {
          return Promise.reject(new PSVError("A cubemap object must contain exactly left, front, right, back, top, bottom images."));
        }
        _CubemapAdapter.CUBE_HASHMAP.forEach(function (side, i) {
          cleanPanorama[i] = panorama[side];
        });
      } else {
        return Promise.reject(new PSVError("Invalid cubemap panorama, are you using the right adapter?"));
      }
      if (this.viewer.config.fisheye) {
        utils_exports.logWarn("fisheye effect with cubemap texture can generate distorsion");
      }
      var promises = [];
      var progress = [0, 0, 0, 0, 0, 0];
      var _loop = function _loop(i) {
        promises.push(_this2.viewer.textureLoader.loadImage(cleanPanorama[i], function (p) {
          progress[i] = p;
          _this2.viewer.loader.setProgress(utils_exports.sum(progress) / 6);
        }).then(function (img) {
          return _this2.createCubemapTexture(img);
        }));
      };
      for (var _i = 0; _i < 6; _i++) {
        _loop(_i);
      }
      return Promise.all(promises).then(function (texture) {
        return {
          panorama: panorama,
          texture: texture
        };
      });
    }
  }, {
    key: "createCubemapTexture",
    value: function createCubemapTexture(img) {
      if (img.width !== img.height) {
        utils_exports.logWarn("Invalid base image, the width equal the height");
      }
      if (this.config.blur || img.width > SYSTEM.maxTextureWidth) {
        var ratio = Math.min(1, SYSTEM.maxCanvasWidth / img.width);
        var buffer = document.createElement("canvas");
        buffer.width = img.width * ratio;
        buffer.height = img.height * ratio;
        var ctx = buffer.getContext("2d");
        if (this.config.blur) {
          ctx.filter = "blur(1px)";
        }
        ctx.drawImage(img, 0, 0, buffer.width, buffer.height);
        return utils_exports.createTexture(buffer);
      }
      return utils_exports.createTexture(img);
    }
  }, {
    key: "createMesh",
    value: function createMesh() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var cubeSize = constants_exports.SPHERE_RADIUS * 2 * scale;
      var geometry = new BoxGeometry(cubeSize, cubeSize, cubeSize).scale(1, 1, -1);
      var materials = [];
      for (var i = 0; i < 6; i++) {
        materials.push(AbstractAdapter.createOverlayMaterial({
          additionalUniforms: {
            rotation: {
              value: 0
            }
          },
          overrideVertexShader: "\nuniform float rotation;\nvarying vec2 vUv;\nconst float mid = 0.5;\nvoid main() {\n  if (rotation == 0.0) {\n    vUv = uv;\n  } else {\n    vUv = vec2(\n      cos(rotation) * (uv.x - mid) + sin(rotation) * (uv.y - mid) + mid,\n      cos(rotation) * (uv.y - mid) - sin(rotation) * (uv.x - mid) + mid\n    );\n  }\n  gl_Position = projectionMatrix *  modelViewMatrix * vec4( position, 1.0 );\n}"
        }));
      }
      return new Mesh(geometry, materials);
    }
  }, {
    key: "setTexture",
    value: function setTexture(mesh, textureData) {
      var texture = textureData.texture;
      for (var i = 0; i < 6; i++) {
        if (this.config.flipTopBottom && (i === 2 || i === 3)) {
          this.__setUniform(mesh, i, "rotation", Math.PI);
        }
        this.__setUniform(mesh, i, AbstractAdapter.OVERLAY_UNIFORMS.panorama, texture[i]);
      }
      this.setOverlay(mesh, null, 0);
    }
  }, {
    key: "setOverlay",
    value: function setOverlay(mesh, textureData, opacity) {
      for (var i = 0; i < 6; i++) {
        this.__setUniform(mesh, i, AbstractAdapter.OVERLAY_UNIFORMS.overlayOpacity, opacity);
        if (!textureData) {
          this.__setUniform(mesh, i, AbstractAdapter.OVERLAY_UNIFORMS.overlay, new Texture());
        } else {
          this.__setUniform(mesh, i, AbstractAdapter.OVERLAY_UNIFORMS.overlay, textureData.texture[i]);
        }
      }
    }
  }, {
    key: "setTextureOpacity",
    value: function setTextureOpacity(mesh, opacity) {
      for (var i = 0; i < 6; i++) {
        this.__setUniform(mesh, i, AbstractAdapter.OVERLAY_UNIFORMS.globalOpacity, opacity);
        mesh.material[i].transparent = opacity < 1;
      }
    }
  }, {
    key: "disposeTexture",
    value: function disposeTexture(textureData) {
      var _textureData$texture;
      (_textureData$texture = textureData.texture) === null || _textureData$texture === void 0 ? void 0 : _textureData$texture.forEach(function (texture) {
        return texture.dispose();
      });
    }
  }, {
    key: "__setUniform",
    value: function __setUniform(mesh, index, uniform, value) {
      if (mesh.material[index].uniforms[uniform].value instanceof Texture) {
        mesh.material[index].uniforms[uniform].value.dispose();
      }
      mesh.material[index].uniforms[uniform].value = value;
    }
  }]);
  return _CubemapAdapter;
}(AbstractAdapter);
var CubemapAdapter = _CubemapAdapter;
CubemapAdapter.CUBE_ARRAY = [0, 2, 4, 5, 3, 1];
CubemapAdapter.CUBE_HASHMAP = ["left", "right", "top", "bottom", "back", "front"];
CubemapAdapter.id = "cubemap";
CubemapAdapter.supportsDownload = false;
CubemapAdapter.supportsOverlay = true;
export { CubemapAdapter };
//# sourceMappingURL=index.module.js.map
